import {isObjectLike} from 'lodash';
import {Middleware} from 'redux';

import {AppAction} from '../store/appActions';
import {AppState} from '../store/appState';
import {Dispatch} from '../store/appStore';

export type AppMiddleware = Middleware<{}, AppState, Dispatch>;

// In Redux 5, the Middleware "action" and "next" parameters are typed as "unknown"
// instead of "any." Most of our reducers expect "AppAction," but there isn't a typeguard
// for that. In this case, checking for the existence of a "type" property is good enough,
// since functions expecting AppAction won't throw if a type is provided.
export function isValidMiddlewareAction(item: any): item is AppAction {
  return isObjectLike(item) && 'type' in item;
}
